/* template */
<template minapp="mpx" xlang="wxml"><div class="scramble-info-wrap"><div class="info"><div class="name">{{ main_train_info.from_station_name }}</div><mpx-image mode="widthFix" :src="(icon)" class="image"></mpx-image><div class="name">{{ main_train_info.to_station_name }}</div></div><div class="alternative"><div class="item"><div class="name">抢票车次</div><div class="text-container"><div v-for="(item, index) in (alternative_train_codes)" class="text">{{ item }}&nbsp;&nbsp;</div></div></div><div class="item"><div class="name">抢票日期</div><div class="text-container"><div v-for="(item, index) in (alternative_start_date)" class="text">{{ item }}&nbsp;&nbsp;</div></div></div><div class="item"><div class="name">抢票坐席</div><div class="text-container"><div v-for="(item, index) in (alternative_seat_code)" class="text">{{ item.seat_name }}&nbsp;&nbsp;</div></div></div><div class="item" v-if="(scrambling)"><div class="name">截止时间</div><div class="text-container"><div class="text">{{ dead_line_hour_text }}</div></div></div><div class="item"><div class="name">乘车人</div><div class="text-container"><div v-for="(item, index) in (passengers)" :key="item.index" class="text"><mpx-image mode="widthFix" src="https://ut-static.udache.com/webx/sfc/dNjyVmQgbR_WI8ZW2Fey9_clipboard_image_1697776600527.png" class="icon"></mpx-image>{{ item }}&nbsp;&nbsp;</div></div></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m74dfd86b"}'>
  @import '~@/mixins/stylus/color.styl'

  .scramble-info-wrap
    border-radius 8px
    background #FFFFFF
    padding-bottom 20px
    margin-bottom 8px
    margin-top 8px
    .info
      margin 0 14px
      padding 16px 0
      border-bottom 0.5px #f0f1f4 solid
      display flex
      align-items center
      .name
        font-family PingFangSC-Semibold
        font-size 16px
        font-weight normal
        line-height 1
        color #333
      .image
        width 16px
        margin 0 6px
    .alternative
      .item
        display flex
        align-items flex-start
        margin-top 15px
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 1
        letter-spacing 0
        &:first-child
          margin-top 17px
        .name
          flex-shrink 0
          color #999
          margin-left 14px
          margin-right 14px
          display inline-block
          width 58px
        .text-container
          flex 1
          padding-right 11px
          display flex
          align-items center
          flex-wrap wrap
          color #000000
          .text
            margin-bottom 6px
          .icon
            width 10px
            margin-right 4px
        .text-gray
          color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m74dfd86b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scramble-info.mpx.js?isComponent&outputPath=components%2Fscramble-info74dfd86b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./scramble-info.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fscramble-info74dfd86b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m74dfd86b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scramble-info74dfd86b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
